import * as Yup from "yup";

const loginValidationSchema = Yup.object({
  mobile: Yup.string()
    .required("Mobile / User ID is required")
    .test("mobile-or-id", "Enter valid Mobile or User ID", function (v) {
      if (!v) return false;
      const isMobile = /^[6-9]\d{9}$/.test(v);
      return isMobile || true;
    }),
  password: Yup.string().required("Password is required"),
});


export const adminValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Name is required"),

  countryId: Yup.string().required("Country ID is required"),
  cityId: Yup.string().required("City ID is required"),
  stateId: Yup.string().required("State ID is required"),

  corporateName: Yup.string()
    .min(2, "Corporate name must be at least 2 characters")
    .max(100, "Corporate name cannot exceed 100 characters")
    .required("Corporate name is required"),
  corporateCode: Yup.string()
    .min(2, "Corporate code must be at least 2 characters")
    .max(50, "Corporate code cannot exceed 50 characters")
    .required("Corporate code is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .max(100, "Contact person cannot exceed 100 characters")
    .required("Contact person is required"),
 
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(100, "Password cannot exceed 100 characters")
    .required("Password is required"),
  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),
});

export const adminUpdateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Name is required"),

  countryId: Yup.string().required("Country ID is required"),
  cityId: Yup.string().required("City ID is required"),
  stateId: Yup.string().required("State ID is required"),

  corporateName: Yup.string()
    .min(2, "Corporate name must be at least 2 characters")
    .max(100, "Corporate name cannot exceed 100 characters")
    .required("Corporate name is required"),
  corporateCode: Yup.string()
    .min(2, "Corporate code must be at least 2 characters")
    .max(50, "Corporate code cannot exceed 50 characters")
    .required("Corporate code is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .max(100, "Contact person cannot exceed 100 characters")
    .required("Contact person is required"),
 
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(100, "Password cannot exceed 100 characters")
    .nullable(),
  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),
});


export const adminTowerValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Name is required"),

  countryId: Yup.string().required("Country is required"),
  cityId: Yup.string().required("City is required"),
  stateId: Yup.string().required("State is required"),

  corporateCodes: Yup.array()
    .of(
      Yup.object().shape({
        adminId: Yup.string().required("Admin is required"),
        code: Yup.string()
          .min(1, "Code is required")
          .required("Code is required"),
      })
    )
    .min(1, "At least 1 corporate code is required"),

  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile is required"),

  email: Yup.string().email("Invalid email").required("Email is required"),

  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .max(100, "Contact person cannot exceed 100 characters")
    .required("Contact person is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(100, "Password cannot exceed 100 characters")
    .required("Password is required"),

  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),
});


export const adminTowerUpdateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Name is required"),

  countryId: Yup.string().required("Country is required"),
  cityId: Yup.string().required("City is required"),
  stateId: Yup.string().required("State is required"),

  // corporateCodes: ARRAY VALIDATION
  corporateCodes: Yup.array()
    .of(
      Yup.object().shape({
        adminId: Yup.string().required("Admin is required"),
        code: Yup.string()
          .min(1, "Code is required")
          .required("Code is required"),
      })
    )
    .min(1, "At least 1 corporate code is required"),

  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile is required"),

  email: Yup.string().email("Invalid email").required("Email is required"),

  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .max(100, "Contact person cannot exceed 100 characters")
    .required("Contact person is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(100, "Password cannot exceed 100 characters")
    .required("Password is required"),

  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),
});



export { loginValidationSchema };
